<template>
  <div class="mt-6">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">Proceso mango 2020</h1>
      </div>
    </div>
    <div
      class="grid grid-cols-1 md:grid-cols-3 gap-y-8 gap-x-2 bg-white rounded-md px-6 py-4 my-6"
    >
      <div class="sm:col-span-1">
        <dt class="text-base font-medium text-gray-500">Fechas</dt>
        <dd class="mt-1 text-base text-gray-900">01 Nov 2020 - 31 Mar 2020</dd>
      </div>
      <div class="sm:col-span-1">
        <dt class="text-base font-medium text-gray-500">Cultivo</dt>
        <dd class="mt-1 text-base text-gray-900">Mango</dd>
      </div>
      <div class="sm:col-span-1">
        <dt class="text-base font-medium text-gray-500">Producto ingresado</dt>
        <dd class="mt-1 text-base text-gray-900">3,000 Jabas de 19 Kg</dd>
      </div>
      <div class="sm:col-span-1">
        <dt class="text-base font-medium text-gray-500">Empaques</dt>
        <dd class="mt-1 text-base text-gray-900">5,000 Cajas de 4.2 Kg</dd>
      </div>
      <div class="sm:col-span-1">
        <dt class="text-base font-medium text-gray-500">Procesado</dt>
        <dd class="mt-1 text-base text-gray-900">20,000 Kg</dd>
      </div>
    </div>
    <div class="mt-8 flex flex-col">
      <TabGroup>
        <TabList class="flex p-1 space-x-1 bg-blue-900/20 rounded-xl">
          <Tab as="template" v-slot="{ selected }">
            <button
              :class="[
                'w-full py-2.5 text-sm leading-5 font-medium text-blue-700 rounded-lg',
                'focus:outline-none focus:ring-2 ring-offset-2 ring-offset-blue-400 ring-white ring-opacity-60',
                selected
                  ? 'bg-white shadow'
                  : 'text-blue-100 hover:bg-white/[0.12] hover:text-white'
              ]"
            >
              Datos
            </button>
          </Tab>
          <Tab as="template" v-slot="{ selected }">
            <button
              :class="[
                'w-full py-2.5 text-sm leading-5 font-medium text-blue-700 rounded-lg',
                'focus:outline-none focus:ring-2 ring-offset-2 ring-offset-blue-400 ring-white ring-opacity-60',
                selected
                  ? 'bg-white shadow'
                  : 'text-blue-100 hover:bg-white/[0.12] hover:text-white'
              ]"
            >
              Gráficos
            </button>
          </Tab>
        </TabList>

        <TabPanels class="mt-2">
          <TabPanel
            :class="[
              'bg-white rounded-xl p-3',
              'focus:outline-none focus:ring-2 ring-offset-2 ring-offset-blue-400 ring-white ring-opacity-60'
            ]"
          >
            <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div
                class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8"
              >
                <div
                  class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
                >
                  <table class="table">
                    <thead class="table-header">
                      <tr>
                        <th scope="col" class="table-header-cell">#</th>
                        <th scope="col" class="table-header-cell">Fecha</th>
                        <th scope="col" class="table-header-cell">Empaques</th>
                        <th scope="col" class="table-header-cell">
                          Total (Kg)
                        </th>
                        <th scope="col" class="table-header-cell">
                          Agro exportadora
                        </th>
                        <th scope="col" class="table-header-cell">
                          Contenedores
                        </th>
                        <th scope="col" class="table-header-cell"></th>
                      </tr>
                    </thead>
                    <tbody class="table-body">
                      <tr
                        class="table-row"
                        v-for="(
                          exported_batch, index_batch
                        ) in exported_batches"
                        :key="exported_batch.id"
                      >
                        <td class="table-cell-pos">{{ index_batch + 1 }}</td>
                        <td class="table-cell">
                          {{ exported_batch.registered_at }}
                        </td>
                        <td class="table-cell">
                          {{ numberWithPrecision(exported_batch.packages, 1) }}
                          Cajas
                        </td>
                        <td class="table-cell">
                          {{ numberWithPrecision(exported_batch.weight_ok, 1) }}
                          kg
                        </td>
                        <td class="table-cell">
                          {{ exported_batch.agro_exporter }}
                        </td>
                        <td class="table-cell">
                          {{ exported_batch.container }}
                        </td>
                        <td class="table-cell-action">
                          <basic-production-details
                            :harvested_batch="exported_batch"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel
            :class="[
              'bg-white rounded-xl p-3',
              'focus:outline-none focus:ring-2 ring-offset-2 ring-offset-blue-400 ring-white ring-opacity-60'
            ]"
          >
            <div class="grid grid-cols-2">
              <apexchart
                type="donut"
                width="380"
                :options="chartOptions"
                :series="series"
              ></apexchart>
              <apexchart
                type="radar"
                height="380"
                :options="chartOptions4"
                :series="series4"
              ></apexchart>
            </div>
            <div id="chart">
              <apexchart
                width="100%"
                height="500"
                type="bar"
                :options="chartOptions2"
                :series="series2"
              ></apexchart>
            </div>
            <div id="chart">
              <apexchart
                width="100%"
                height="500"
                type="line"
                :options="chartOptions3"
                :series="series2"
              ></apexchart>
            </div>

            <div id="wrap">
              <select id="model" class="flat-select" @change="changeData">
                <option value="iphone5">iPhone 5</option>
                <option value="iphone6">iPhone 6</option>
                <option value="iphone7">iPhone 7</option>
              </select>
              <div id="chart-year">
                <apexchart
                  type="bar"
                  height="400"
                  ref="chart"
                  :options="chartOptions5"
                  :series="series5"
                ></apexchart>
              </div>
              <div id="chart-quarter">
                <apexchart
                  type="bar"
                  height="400"
                  ref="chartQuarter"
                  :options="chartOptionsQuarter"
                  :series="seriesQuarter"
                ></apexchart>
              </div>
            </div>
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </div>
  </div>
</template>

<script>
import BasicProductionDetails from "@/components/views/open_queries/packing_house/BasicProductionDetails.vue";
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from "@headlessui/vue";
import VueApexCharts from "vue3-apexcharts";
import ApexCharts from "apexcharts";
var colors = [
  "#008FFB",
  "#00E396",
  "#FEB019",
  "#FF4560",
  "#775DD0",
  "#00D9E9",
  "#FF66C3"
];
export default {
  name: "OQProducerBasicProduction",
  components: {
    "basic-production-details": BasicProductionDetails,
    apexchart: VueApexCharts,
    TabGroup,
    TabList,
    Tab,
    TabPanels,
    TabPanel
  },
  mixins: [ApexCharts],
  props: {
    organization_id: {},
    process_id: {}
  },
  data() {
    return {
      exported_batches: [
        {
          registered_at: "01 Ene 2020",
          packages: 1723,
          weight_ok: 4736,
          agro_exporter: "Fairtrasa",
          container: "TEMU0987652"
        }
      ],
      series: [44, 55, 13, 31],
      chartOptions: {
        title: {
          text: "Agro exportadores"
        },
        chart: {
          width: 380,
          type: "donut"
        },
        labels: ["Fairtrasa", "Dominus", "Frutos del Perú", "Peru Export"],
        dataLabels: {
          enabled: true
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300
              },
              legend: {
                show: true
              }
            }
          }
        ],
        legend: {
          position: "right",
          offsetY: 0,
          height: 230
        }
      },

      series2: [
        {
          name: "Fairtrasa",
          data: [44, 55, 41, 67, 22, 43, 39, 58, 21]
        },
        {
          name: "Dominus",
          data: [13, 23, 20, 8, 13, 27, 37, 19, 10]
        },
        {
          name: "Frutos del Perú",
          data: [11, 17, 15, 15, 21, 14, 10, 32, 0]
        },
        {
          name: "Peru Export",
          data: [21, 7, 25, 13, 22, 8, 0, 24, 35]
        }
      ],
      chartOptions2: {
        title: {
          text: "Cajas/Agroexportadora Semanal"
        },
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 3
          }
        },
        xaxis: {
          type: "number",
          title: { text: "Semanas" },
          categories: ["48", "49", "50", "51", "52", "01", "02", "03", "04"]
        },
        yaxis: {
          title: { text: "# Cajas" }
        },
        legend: {
          position: "right",
          offsetY: 40
        },
        fill: {
          opacity: 1
        }
      },
      chartOptions3: {
        chart: {
          height: 350,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
          toolbar: {
            show: false
          }
        },
        colors: ["#018FFB", "#14E396", "#FEB01A", "#FF4560"],
        dataLabels: {
          enabled: true
        },
        stroke: {
          curve: "straight"
        },
        title: {
          text: "Cajas/Agroexportadora Semanal",
          align: "left"
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        markers: {
          size: 1
        },
        xaxis: {
          categories: [
            "48",
            "49",
            "50",
            "51",
            "52",
            "01",
            "02",
            "03",
            "04",
            "05"
          ],
          title: {
            text: "Month"
          }
        },
        yaxis: {
          title: {
            text: "# cajas"
          },
          min: 0,
          max: 75
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5
        }
      },
      series4: [
        {
          name: "K10",
          data: [80, 50, 30, 40, 100, 20]
        },
        {
          name: "K08",
          data: [20, 30, 40, 80, 20, 80]
        },
        {
          name: "K07",
          data: [44, 76, 78, 13, 43, 10]
        }
      ],
      chartOptions4: {
        chart: {
          height: 380,
          type: "radar",
          dropShadow: {
            enabled: true,
            blur: 1,
            left: 1,
            top: 1
          }
        },
        title: {
          text: "Calibres"
        },
        stroke: {
          width: 2
        },
        fill: {
          opacity: 0.1
        },
        markers: {
          size: 0
        },
        xaxis: {
          categories: ["Oct", "Nov", "Dec", "Ene", "Feb", "Mar"]
        },
        legend: {
          position: "right",
          offsetY: 0,
          offsetX: 20,
          height: 230
        }
      },

      series5: [
        {
          data: this.makeData()
        }
      ],
      chartOptions5: {
        chart: {
          id: "barYear",
          height: 400,
          width: "100%",
          type: "bar",
          events: {
            click: function (event, chartContext, config) {
              event;
              chartContext;
              config;
              console.log('click');
            },
            dataPointSelection: function (e, chart, opts) {
              console.log("dataPointSelection", e, chart, opts);
              var quarterChartEl = document.querySelector("#chart-quarter");
              var yearChartEl = document.querySelector("#chart-year");

              if (opts.selectedDataPoints[0].length === 1) {
                if (quarterChartEl.classList.contains("active")) {
                  this.updateQuarterChart(chart, "barQuarter");
                } else {
                  yearChartEl.classList.add("chart-quarter-activated");
                  quarterChartEl.classList.add("active");
                  this.updateQuarterChart(chart, "barQuarter");
                }
              } else {
                this.updateQuarterChart(chart, "barQuarter");
              }

              if (opts.selectedDataPoints[0].length === 0) {
                yearChartEl.classList.remove("chart-quarter-activated");
                quarterChartEl.classList.remove("active");
              }
            },
            updated: function (chart) {
              this.updateQuarterChart(chart, "barQuarter");
            }
          }
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
            barHeight: "75%",
            dataLabels: {
              position: "bottom"
            }
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: {
            colors: ["#fff"]
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex];
          },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },

        colors: colors,

        states: {
          normal: {
            filter: {
              type: "desaturate"
            }
          },
          active: {
            allowMultipleDataPointsSelection: true,
            filter: {
              type: "darken",
              value: 1
            }
          }
        },
        tooltip: {
          x: {
            show: false
          },
          y: {
            title: {
              formatter: function (val, opts) {
                return opts.w.globals.labels[opts.dataPointIndex];
              }
            }
          }
        },
        title: {
          text: "Yearly Results",
          offsetX: 15
        },
        subtitle: {
          text: "(Click on bar to see details)",
          offsetX: 15
        },
        yaxis: {
          labels: {
            show: false
          }
        }
      },

      seriesQuarter: [
        {
          data: []
        }
      ],
      chartOptionsQuarter: {
        chart: {
          id: "barQuarter",
          height: 400,
          width: "100%",
          type: "bar",
          stacked: true
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            horizontal: false
          }
        },
        legend: {
          show: false
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: true
            }
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        title: {
          text: "Quarterly Results",
          offsetX: 10
        },
        tooltip: {
          x: {
            formatter: function (val, opts) {
              return opts.w.globals.seriesNames[opts.seriesIndex];
            }
          },
          y: {
            title: {
              formatter: function (val, opts) {
                return opts.w.globals.labels[opts.dataPointIndex];
              }
            }
          }
        }
      }
    };
  },
  methods: {
    fetchHarvestedBatches: async function () {},
    changeData: function () {
      this.$refs.chart.updateSeries([
        {
          data: this.makeData()
        }
      ]);
    },
    shuffleArray(array) {
      for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },

    makeData() {
      var arrayData = [
        {
          y: 400,
          quarters: [
            {
              x: "Q1",
              y: 120
            },
            {
              x: "Q2",
              y: 90
            },
            {
              x: "Q3",
              y: 100
            },
            {
              x: "Q4",
              y: 90
            }
          ]
        },
        {
          y: 430,
          quarters: [
            {
              x: "Q1",
              y: 120
            },
            {
              x: "Q2",
              y: 110
            },
            {
              x: "Q3",
              y: 90
            },
            {
              x: "Q4",
              y: 110
            }
          ]
        },
        {
          y: 448,
          quarters: [
            {
              x: "Q1",
              y: 70
            },
            {
              x: "Q2",
              y: 100
            },
            {
              x: "Q3",
              y: 140
            },
            {
              x: "Q4",
              y: 138
            }
          ]
        },
        {
          y: 470,
          quarters: [
            {
              x: "Q1",
              y: 150
            },
            {
              x: "Q2",
              y: 60
            },
            {
              x: "Q3",
              y: 190
            },
            {
              x: "Q4",
              y: 70
            }
          ]
        },
        {
          y: 540,
          quarters: [
            {
              x: "Q1",
              y: 120
            },
            {
              x: "Q2",
              y: 120
            },
            {
              x: "Q3",
              y: 130
            },
            {
              x: "Q4",
              y: 170
            }
          ]
        },
        {
          y: 580,
          quarters: [
            {
              x: "Q1",
              y: 170
            },
            {
              x: "Q2",
              y: 130
            },
            {
              x: "Q3",
              y: 120
            },
            {
              x: "Q4",
              y: 160
            }
          ]
        }
      ];
      var dataSet = this.shuffleArray(arrayData);

      var dataYearSeries = [
        {
          x: "2011",
          y: dataSet[0].y,
          color: colors[0],
          quarters: dataSet[0].quarters
        },
        {
          x: "2012",
          y: dataSet[1].y,
          color: colors[1],
          quarters: dataSet[1].quarters
        },
        {
          x: "2013",
          y: dataSet[2].y,
          color: colors[2],
          quarters: dataSet[2].quarters
        },
        {
          x: "2014",
          y: dataSet[3].y,
          color: colors[3],
          quarters: dataSet[3].quarters
        },
        {
          x: "2015",
          y: dataSet[4].y,
          color: colors[4],
          quarters: dataSet[4].quarters
        },
        {
          x: "2016",
          y: dataSet[5].y,
          color: colors[5],
          quarters: dataSet[5].quarters
        }
      ];

      return dataYearSeries;
    },
    updateQuarterChart(sourceChart, destChartIDToUpdate) {
      var seriesIndex = 0;
      var colors = [];
      this.seriesQuarter = [
        {
          data: [1]
        }
      ];
      if (sourceChart.w.globals.selectedDataPoints[0]) {
        var selectedPoints = sourceChart.w.globals.selectedDataPoints;
        for (var i = 0; i < selectedPoints[seriesIndex].length; i++) {
          var selectedIndex = selectedPoints[seriesIndex][i];
          var yearSeries = sourceChart.w.config.series[seriesIndex];
          this.seriesQuarter.push({
            name: yearSeries.data[selectedIndex].x,
            data: yearSeries.data[selectedIndex].quarters
          });
          colors.push(yearSeries.data[selectedIndex].color);
        }
        if (this.seriesQuarter.length === 0)
          this.seriesQuarter = [
            {
              data: []
            }
          ];
        console.log("series", this.seriesQuarter);
        return VueApexCharts.exec(destChartIDToUpdate, "updateOptions", {
          series: this.seriesQuarter,
          colors: colors,
          fill: {
            colors: colors
          }
        });
      }
    }
  },
  beforeMount() {
    this.checkIfAuthenticated();
    // this.fetchHarvestedBatches();
  }
};
</script>
